import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { lockBodyScroll, unlockBodyScroll } from '../utils/bodyScrollLock';

const MIN_DURATION_MS = 550;

export const useRouteTransitionLoader = () => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }

    setIsTransitioning(true);
    lockBodyScroll();

    const startedAt = performance.now();
    let timeoutId;

    const finish = () => {
      const remaining = Math.max(0, MIN_DURATION_MS - (performance.now() - startedAt));
      timeoutId = window.setTimeout(() => {
        setIsTransitioning(false);
        unlockBodyScroll();
      }, remaining);
    };

    const rafId = requestAnimationFrame(() => {
      requestAnimationFrame(finish);
    });

    return () => {
      cancelAnimationFrame(rafId);
      window.clearTimeout(timeoutId);
      unlockBodyScroll();
    };
  }, [location.pathname]);

  return isTransitioning;
};
